export default __webpack_public_path__ + "6c1734c989fe5285a73f779e0b1306d2.png";